export default "__VITE_ASSET__6b2fe5f0__"